import React, { useEffect } from 'react';
import { Alert } from 'components/common';
import { useDataModel, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { DataModelSchema } from 'schemas';
import DataModelFormDumb from './DataModelFormDumb';


const DataModelCreateSmart = () => {
  const { parameters,filters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, postDataModel } = useDataModel();

  const defaultValues = {
    name: '',
    project: filters.project?parseInt(filters.project):0,
    additionalVariables: '',
    language: 'json'
  };

  const handleCloseAlert = () => cleanUpMessage();
  
  const findProject = (project) => {
    return projects.find(p => Number(p.value) === Number(project));    
  }

  const handleCreate = (data) => {
  
    const dataModel = new DataModelSchema();
    data.name = `${data.name}.${data.language}`;
    dataModel.setValues(data);
    const project = findProject(data.project);
    dataModel.values.baseUrl = project.base_url; 
    dataModel.values.fromEdit = false;
    postDataModel({
      body: dataModel.getValues(),
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.DATA_MODEL_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      { projects && <DataModelFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} />}
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="dataModelCreate.components.alert.error" />
    </>
  );
};

export default withRequest(withRouter(DataModelCreateSmart));
